import { useNavigate } from "react-router-dom";
import artistFallback from "./../assets/fallback/artist_fallback.webp";
import splashFallback from "./../assets/fallback/artist_splash_fallback.webp";
import Badge from "./Badge";

const BandBigDisplayBlock = ({ band }) => {
  const navigate = useNavigate();
  const bandUrl = "/music/" + band.slug;
  const bandUrlAlt = "Profilsida för" + band.name;

  const profileImage = band.image_profile || artistFallback;
  const splashImage = band.image_splash || splashFallback;

  return (
    <>
      <div className="group card rounded-2xl bg-[#131313] border border-white/10 xl:w-96 shadow-xl relative overflow-hidden transition-all duration-300 hover:scale-[1.02] hover:border-white/20">
        {band.constellation_type && (
          <div className="absolute top-3 right-3 z-10">
            <Badge text={band.constellation_type} type="band-type" />
          </div>
        )}
        <figure className="h-60 sm:h-96 xl:h-60 overflow-hidden relative">
          <a
            href={bandUrl}
            alt={`Besök ${band.name}´s profilsida`}
            className="w-full h-full block"
          >
            <img
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              src={splashImage}
              alt={band.name + "´s splashbild"}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#131313] via-transparent to-transparent opacity-60" />
          </a>
        </figure>
        <div className="card-body p-5">
          <a href={bandUrl} alt={bandUrlAlt}>
            <h2 className="mb-2 text-white font-extrabold uppercase tracking-wide text-2xl truncate">
              {band.name}
            </h2>
          </a>
          <div className="xl:h-24">
            <p className="text-stone-400 text-sm leading-relaxed line-clamp-3">
              {band.description}
            </p>
          </div>
          <div className="flex flex-nowrap overflow-hidden gap-2 my-3">
            <Badge
              text={band.genre_main}
              type="genre-main"
              href={`/search?page=1&q=${band.genre_main}&include=tags`}
            />
            {band.genre_sub.map((genre, index) => (
              <Badge
                key={index}
                text={genre.name}
                type="genre-sub"
                href={`/search?page=1&q=${genre.name}&include=tags`}
              />
            ))}
          </div>
          <button
            className="btn w-full bg-[#0047ff] hover:bg-blue-700 text-white border-none rounded-full font-bold uppercase tracking-wider text-xs py-3.5 transition-transform duration-300 hover:scale-[1.03]"
            onClick={() => navigate(bandUrl)}
            aria-label={`Besök profilsidan för ${band.name}`}
          >
            Besök
          </button>
        </div>
      </div>
    </>
  );
};

export default BandBigDisplayBlock;
